<template>
  <tbody class="bg-white dark:bg-dark-800 divide-y divide-gray-200 dark:divide-gray-700">
    <slot></slot>
  </tbody>
</template>

<script>
export default {
  name: 'TableBody'
}
</script>
